import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import { PagesBanner } from '../'
import './CMSListing.sass'


function renderEntries(entries) {
  return entries.map((entry, idx) =>
    <div key={idx} className="cms-listing__entry">
      <p>{entry.title}</p>
      {entry.url &&
        <a
          href={entry.url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-blue-transparent-sm"
        >
          view
        </a>
      }
    </div>
  )
}

const CMSListing = ({ contentData, bgClassName }) => {
  return (
    <div className="page__wrapper">
      <Helmet>
        <title>{contentData.title} | Gulf TREE</title>
      </Helmet>
      <PagesBanner bgClassName={bgClassName} title={contentData.title} />
      <section className="page__content markdown-bullet-list">
        {renderEntries(contentData.listing_items)}
      </section>
    </div>
  )
}

CMSListing.propTypes = {
  contentData: PropTypes.shape({
    listing_items: PropTypes.array.isRequired,
    title: PropTypes.string
  }),
  bgClassName: PropTypes.string
}

export default CMSListing
